import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import { getDevice } from '@/utils'
import { http } from '@/service'
import urlParse from "@/utils/urlParse";
import dsBridge from "@/utils/dsbridge";
import '@/utils/rem'
import './styles/element-variables.scss'
import vueSignature from "vue-signature"
import { regex } from "@/utils/regex"
import Bridg from "./mixins/Bridge";
import {
	AlertPlugin,
	ToastPlugin,
	ConfirmPlugin,
} from "vux";
Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(vueSignature)
Vue.use(ToastPlugin);
Vue.use(AlertPlugin);
Vue.use(ConfirmPlugin);
Vue.prototype.$http = http
Vue.prototype.$device = getDevice()
Vue.prototype.$regex = regex

const urlData = urlParse();
const CLIENT = {
	//本地开发数据，項目中 可以通过  this.$client.userid 的格式来获取
	// userid: "907106903739269120", //用户id
	userid: "1139361991996465152", //用户id
	orgid: "977090533766828033", // 机构编號
	shopid: "998762536365064193", // 店铺id
	webview: 2, // 浏览器环境 1: iOS | 2: Android | 3: H5
	right: "store", // 权限  staging: 工作台 | store: 店铺
	usertype: "2", // 用户类型
	crocsid: null, // 第二次登入的門市机构id
	umallhk: "dw1hbgxis+wdkewvig", // 判斷是否是在app裡面 一個自己都不認識的參數
	appletUserId: ''
};
console.log(process.env.NODE_ENV, '43')
const clientData =
	process.env.NODE_ENV === "production" ?
	urlData :
	Object.assign({}, CLIENT, urlData);
for(const key in clientData) {
	//这里做一个统一转小写的處理，防止客户端大小写没有传对。
	const val = clientData[key];
	clientData[key] = typeof val === "string" ? val.toLowerCase() : val;
}
window.sessionStorage.setItem("client", JSON.stringify(clientData)); //存储起来，在main.js  router.beforeEach 会判断
Vue.prototype.$client = clientData;

Vue.prototype.$isDebug = process.env.NODE_ENV == 'production' ? false : true
Vue.prototype.$session = {
	//sessionStorage封装
	get(key) {
		return sessionStorage.getItem(key) ?
			JSON.parse(sessionStorage.getItem(key)) :
			"";
	},
	set(key, val) {
		sessionStorage.setItem(key, JSON.stringify(val));
	},
	remove(key) {
		sessionStorage.removeItem(key);
	},
	clear() {
		sessionStorage.clear();
	}
};

dsBridge.call("js2webview", {
	type: 7
}, function() {
	store.dispatch("set_APP", 1);
	console.log("支持js桥");
});

Vue.prototype.$jb = {
	webview2js(callback) {
		//   console.log("W2J");
		//   console.log(callback);
		dsBridge.register("webview2js", callback);
	},
	js2webview(arg, callback = () => {}) {
		dsBridge.call("js2webview", arg, callback);
	}
};
/**
 * Bridg
 * @module mixin/Bridge
 * @returns { number } $APP 0：不是 1：是 是否在APP内
 * @returns { number }  $isStore 是否是是店铺 1：店铺 2：工作台
 
 */
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || "eShop網上簽約";
  dsBridge.call(
    "js2webview",
    { type: 5, title: document.title },
    function() {}
  );
  dsBridge.call("js2webview", { type: 4, btns: [] }, function() {}); //重置掉按鈕
  next();
});
Vue.mixin(Bridg); // 全局变量
/**
       * 调用示例
        this.$jb.webview2js((params) => {     
            params.type == 1 && this.$router.go(-1)
          })
        this.$jb.js2webview({
          type: 1,
          isShare: 2
        }, function (params) {
          this.$vux.toast.text(JSON.stringify(params))
        })
       */
new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')